export default "__VITE_ASSET__a8a650c5__"